<template>
  <!-- Teleport above .wrapper (z-index 1080) / sidebar (up to 1099) so full-page overlays
       are not clipped or covered by the sidebar (Summary Reports, datatables, etc.). -->
  <Teleport to="body" :disabled="!teleportToBody">
    <div
      v-show="isProcessing"
      class="loader-container"
      :class="[classes, { 'loader-container--body-portal': teleportToBody }]"
      :aria-busy="isProcessing ? 'true' : 'false'"
      :aria-hidden="isProcessing ? undefined : 'true'"
    >
      <!-- Spinner + message are visual only; loading status is announced via the persistent
           global live region (useLiveAnnouncer) so it reliably fires while shown. -->
      <CSpinner color="primary" id="cloader" aria-hidden="true" />
      <div
        v-if="loaderText"
        class="loader-container__message"
        aria-hidden="true"
      >
        {{ loaderText }}
      </div>
    </div>
  </Teleport>
</template>

<script>
import { announce } from "@/composables/useLiveAnnouncer"

/* Spinner/message are decorative; loading status is announced through the persistent
   global live region (useLiveAnnouncer) unless the parent owns the announcement. */
export default {
  name: "Loader",
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ""
    },
    /** When true (default), render via Teleport to document.body so fixed overlay stacks above the sidebar. Set false for in-card loaders (e.g. position-absolute). */
    teleportToBody: {
      type: Boolean,
      default: true
    },
    loaderText: {
      type: String,
      default: ""
    },
    /** Parent owns loading status (e.g. dashboard live region). Spinner stays visual-only for AT. */
    statusAnnouncedExternally: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isProcessing: {
      immediate: true,
      handler(processing) {
        if (processing && !this.statusAnnouncedExternally) {
          announce(this.accessibleLabel)
        }
      }
    }
  },
  computed: {
    spinnerAnnouncesStatus() {
      return !this.statusAnnouncedExternally && !this.loaderText?.trim?.()
    },
    accessibleLabel() {
      const custom = this.loaderText?.trim?.() || ""
      if (custom) return custom
      const t = this.$t
      if (typeof t === "function") {
        return t("common.a11y_loading")
      }
      /* Tests / mounts without vue-i18n */
      return "Loading"
    }
  }
}
</script>
<style>
#cloader {
  width: 4rem;
  height: 4rem;
}
</style>
